module.exports = __webpack_public_path__ + "static/media/industrial.f58e7ac3.webp";